// Vuex Store 入口
import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user'
import report from './modules/report'
import app from './modules/app'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    user,
    report,
    app
  }
})

